// Initializes Firebase App Check with reCAPTCHA Enterprise.
// Import for side-effects from main.tsx before any Firebase product is used.

import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check'
import { app } from './app'

const siteKey = import.meta.env.VITE_FIREBASE_APPCHECK_SITE_KEY as string | undefined

// Debug token printed in the browser console on first run in dev.
// Register the token in Firebase Console → App Check → Manage debug tokens so
// localhost traffic passes enforcement.
if (import.meta.env.DEV) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ;(self as any).FIREBASE_APPCHECK_DEBUG_TOKEN = true
}

if (siteKey) {
  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(siteKey),
    isTokenAutoRefreshEnabled: true,
  })
} else if (import.meta.env.PROD) {
  // Fail loud in prod if the site key is missing — App Check is a security control.
  throw new Error(
    'Missing VITE_FIREBASE_APPCHECK_SITE_KEY. App Check cannot initialize.'
  )
}
